import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OnboardingInitializationBody } from '@interfaces/open-choice';
import type {
  ClientDetailsRequestBody,
  ClientEligibilityBody,
  ClientEligibilityResponse,
  ClientEnrollmentResponse,
} from '@interfaces/open-choice/digital-advice.types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DigitalAdviceService {
  constructor(private http: HttpClient) {}

  private buildURI(uri: string) {
    return `secure/digital-advice/${uri}`;
  }

  clientEligibility(body: ClientEligibilityBody): Observable<ClientEligibilityResponse> {
    return this.http.post<ClientEligibilityResponse>(this.buildURI('eligibility/client'), body);
  }

  onboardInitClient(data: OnboardingInitializationBody): Observable<void> {
    return this.http.post<void>(this.buildURI(`onboarding-initialization/client`), data);
  }

  rollbackOffer(): Observable<void> {
    return this.http.post<void>(this.buildURI('rollback'), {});
  }

  clientEnrollment(requestBody: ClientDetailsRequestBody): Observable<ClientEnrollmentResponse> {
    return this.http.post<ClientEnrollmentResponse>(this.buildURI('enrollment'), requestBody);
  }
}
